import styled from 'styled-components';

export const FormStack = styled.form`
   display: grid;
   gap: 16px;
   max-width: 420px;
`;

export const FormActions = styled.div`
   display: flex;
   gap: 10px;
   justify-content: flex-end;
   max-width: 420px;
   margin-top: 4px;
`;

export const ReadOnlyNote = styled.p`
   margin: 0 0 10px;
   max-width: 420px;

   font-size: 13px;
   line-height: 1.5;
   color: ${({ theme }) => theme.colors.textMuted};
`;
